/**
 * OtpCodeValidEnum
 */
export enum OtpCodeInvalidEnum {
  "OTP200" = "OTP200",
}



// WEBPACK FOOTER //
// ./src/shared/OtpCodeInvalidEnum.ts